import React from 'react'

export interface DateStepProp {
   items: string[]
}

const DateStepView: React.FC<DateStepProp> = ({ items }) => {
    return (
        <>
            {
                items.map(item =>
                    <div className="inner-phases">
                        <p>{item}</p>
                    </div>
                )
            }
        </>
    )
}

export default DateStepView
